import { render, staticRenderFns } from "./mockup3.vue?vue&type=template&id=dac8f836&scoped=true&"
import script from "./mockup3.vue?vue&type=script&lang=js&"
export * from "./mockup3.vue?vue&type=script&lang=js&"
import style0 from "./mockup3.vue?vue&type=style&index=0&id=dac8f836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac8f836",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/andres/repositories/merge/webapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCalendar } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VCombobox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VAlert,VAvatar,VBtn,VCalendar,VCard,VCardActions,VCardText,VCardTitle,VChip,VCombobox,VContainer,VDatePicker,VDialog,VDivider,VFlex,VForm,VIcon,VLayout,VList,VListTile,VListTileAction,VListTileContent,VListTileTitle,VMenu,VProgressLinear,VSelect,VSpacer,VSwitch,VTextField,VTextarea,VToolbar,VToolbarTitle,VTooltip})
